import { ReactNode } from "react";
import {
    useForm,
    FormProvider,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { cn } from "@/utils/cn";
import { Button } from "@/components/atoms/Button";
import { SaveIcon } from "lucide-react";
import { FormStatusEnum, FormWrapperProps } from "./FormWrapper.types";
import { TrashIcon } from "@heroicons/react/24/outline";


export const FormWrapper = <TFormValues extends Record<string, any>>({
    children,
    onSubmit,
    defaultValues,
    schema,
    className,
    formStatus,
    onDelete,
    canSave = true,
    canDelete = true,
}: FormWrapperProps<TFormValues>) => {
    const methods = useForm<TFormValues>({
        resolver: schema ? zodResolver(schema) : undefined,
        defaultValues,
    });

    const { getValues } = methods;

    const resolvedChildren: ReactNode =
        typeof children === "function" ? children(methods) : children;

    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className={cn(className || "space-y-4", "border rounded-md p-6 shadow-neumorph")}
            >
                {resolvedChildren}
                <div className="flex justify-end space-x-2">
                    {formStatus === FormStatusEnum.Edit && canDelete && (
                        <Button size="xs" variant="danger" onClick={() => {
                            const values = getValues();
                            const id = values.id;
                            onDelete(id);
                        }}>
                            <TrashIcon className="h-6 w-6" aria-hidden="true" />
                        </Button>
                    )}
                    {canSave && <Button size="xs" type="submit">
                        <SaveIcon className="h-6 w-6" aria-hidden="true" />
                    </Button>}
                </div>
            </form>
        </FormProvider>
    );
};
